import { render, staticRenderFns } from "./BuildingRule.vue?vue&type=template&id=1bf09b48&"
import script from "./BuildingRule.vue?vue&type=script&lang=js&"
export * from "./BuildingRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports